class ShippingRates extends HTMLElement {
  constructor() {
    super();

    this.zipCode = "";

    this.querySelector("input").onkeyup = () => this.zipcodeMask();

    this.querySelector("#submit-zipcode").onclick = () =>
      this.calculateShippingRates();

    document
      .querySelectorAll(".cart-item__quantity-input")
      .forEach((quantity) => {
        document.querySelector("#submit-zipcode").click();
      });
  }

  zipcodeMask() {
    let zipcode = this.querySelector("input").value;
    zipcode = zipcode
      .replace(/\D/g, "")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .replace(/(-\d{3})\d+?$/, "$1");

    this.querySelector("input").value = zipcode;

    if (this.querySelector("input").value.length === 9) {
      this.querySelector("#submit-zipcode").disabled = false;
      this.zipCode = zipcode;
    } else this.querySelector("#submit-zipcode").disabled = true;
  }

  calculateShippingRates() {
    var this2 = this;

    this2.querySelector("#rates").innerHTML = "";
    this2.querySelector("#submit-zipcode").innerHTML =
      '<div class="loading-spinner"></div>';
    this2.querySelector("#submit-zipcode").disabled = true;

    fetch(
      `/cart/shipping_rates.json?shipping_address[zip]=${this2.zipCode}&shipping_address[country]=Brazil&shipping_address[province]=SP`,
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (response) {
      response.json().then(function (result) {
        this2.querySelector("#submit-zipcode").innerHTML = "Calcular";
        this2.querySelector("#submit-zipcode").disabled = false;
        result.shipping_rates.unshift({
          name: "Retirada no local",
          price: "0.00",
          delivery_days: [1, 1],
        });
        result.shipping_rates.forEach((rate) => {
          const node = document.createElement("li");
          if (rate.name === "Local Delivery") rate.name = "Entrega local";
          if (!rate.delivery_days[1]) {
            rate.delivery_days = [1, 1];
          }
          console.log("rate.delivery_days: ", rate.delivery_days);
          node.innerText = `${rate.name}: ${
            rate.price === "0.00"
              ? "grátis"
              : "R$ " + rate.price.replace(".", ",")
          } - Até ${rate.delivery_days[1]} dias úteis`;
          this2.querySelector("#rates").appendChild(node);
        });
      });
    });
  }
}

customElements.define("shipping-rates", ShippingRates);
